import api from './axios';

// Get all slides
export const getAllSlides = async () => {
  const response = await api.get('/slider');
  return response.data;
};

// Get active slides only
export const getActiveSlides = async () => {
  const response = await api.get('/slider/active');
  return response.data;
};

// Get single slide
export const getSlideById = async (id) => {
  const response = await api.get(`/slider/${id}`);
  return response.data;
};

// Create new slide
export const createSlide = async (formData) => {
  const response = await api.post('/slider', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update slide
export const updateSlide = async (id, formData) => {
  const response = await api.patch(`/slider/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete slide
export const deleteSlide = async (id) => {
  const response = await api.delete(`/slider/${id}`);
  return response.data;
};

// Reorder slides
export const reorderSlides = async (slideIds) => {
  const response = await api.patch('/slider/reorder', { slideIds });
  return response.data;
};

const sliderService = {
  getAllSlides,
  getActiveSlides,
  getSlideById,
  createSlide,
  updateSlide,
  deleteSlide,
  reorderSlides,
};

export default sliderService;
